export default "__VITE_ASSET__CtmIwkVF__"